import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Box, Tab, Tabs, Typography } from "@mui/material";

export default function DashboardsLayout() {
  const location = useLocation();
  const tabs = [
    { label: "Analysis", path: "/dashboards/analysis" },
    { label: "Engagement", path: "/dashboards/engagement" },
    { label: "Performance", path: "/dashboards/performance" },
  ];

  const activeIndex = tabs.findIndex((tab) =>
    location.pathname.startsWith(tab.path)
  );

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight="bold">
          Video Dashboard
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Video analysis, likes/dislikes, engagement, and performance in one place.
        </Typography>
      </Box>
      <Tabs
        value={activeIndex === -1 ? false : activeIndex}
        sx={{
          mb: 2,
          "& .MuiTabs-indicator": {
            backgroundColor: "#3f7a2a",
            height: 3,
            borderRadius: "3px 3px 0 0",
          },
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 500,
            color: "#62715d",
            "&.Mui-selected": {
              color: "#3f7a2a",
              fontWeight: 700,
            },
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.path} component={NavLink} to={tab.path} label={tab.label} />
        ))}
      </Tabs>
      <Outlet />
    </Box>
  );
}
